module.exports = __webpack_public_path__ + "img/yh.cd273556.svg";